import React from "react";

const LinkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.66659 3.33331C2.66659 2.96512 2.96506 2.66665 3.33325 2.66665H7.99992C8.36811 2.66665 8.66659 2.36817 8.66659 1.99998C8.66659 1.63179 8.36811 1.33331 7.99992 1.33331H3.33325C2.22868 1.33331 1.33325 2.22874 1.33325 3.33331V12.6666C1.33325 13.7712 2.22868 14.6666 3.33325 14.6666H12.6666C13.7712 14.6666 14.6666 13.7712 14.6666 12.6666V7.99998C14.6666 7.63179 14.3681 7.33331 13.9999 7.33331C13.6317 7.33331 13.3333 7.63179 13.3333 7.99998V12.6666C13.3333 13.0348 13.0348 13.3333 12.6666 13.3333H3.33325C2.96506 13.3333 2.66659 13.0348 2.66659 12.6666V3.33331Z"
        fill="#537BFF"
      />
      <path
        d="M9.99992 1.99998C9.99992 1.63179 10.2984 1.33331 10.6666 1.33331H13.3333C14.0696 1.33331 14.6666 1.93027 14.6666 2.66665V5.33331C14.6666 5.7015 14.3681 5.99998 13.9999 5.99998C13.6317 5.99998 13.3333 5.7015 13.3333 5.33331V3.60946L8.47132 8.47138C8.21097 8.73173 7.78886 8.73173 7.52851 8.47138C7.26816 8.21103 7.26816 7.78892 7.52851 7.52858L12.3904 2.66665H10.6666C10.2984 2.66665 9.99992 2.36817 9.99992 1.99998Z"
        fill="#537BFF"
      />
    </svg>
  );
};

export default LinkIcon;
